//Reference: EN095

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash'
export class TimeAllocationConcept extends Mappeable {
    idTypeConceptImputationPk: number;
    txtTypeConceptImputation: string;
    imputablePai: boolean;
    imputationsChildren: any[];
    typeConceptImputationFatherId: any;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.imputationsChildren = this.imputationsChildren ??  [] 
        this.imputablePai = this.imputablePai ??  false 
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            idTypeConceptImputationPk: this.idTypeConceptImputationPk,
            imputablePai: this.imputablePai,
            txtTypeConceptImputation: this.txtTypeConceptImputation,
            imputationsChildren: this.imputationsChildren,
            typeConceptImputationFatherId: this.typeConceptImputationFatherId,
            mrkActive: this.mrkActive
        }
    }
}
